import React from 'react';
import PropTypes from 'prop-types';
import { default as MuiTextField } from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from './IconButton';
import TextEditorDialog from './TextEditorDialog';

const TextEditor = (props) => {
	const [showPopup, setShowPopup] = React.useState(false);
	const [popupValue, setPopupValue] = React.useState('');

	const onChange = (value, event) => {
		if (props.onChange) {
			props.onChange(event || null, value);
		}
	};

	const onShowPopup = () => {
		setPopupValue(props.value || '');
		setShowPopup(true);
	};

	const onHidePopup = () => {
		setShowPopup(false);
	};

	const onSubmitPopup = (value) => {
		onChange(value);
		setShowPopup(false);
	};

	const mergedProps = { ...props };
	mergedProps.InputProps = mergedProps.InputProps || {};

	if (props.inputStyle) {
		mergedProps.InputProps.inputProps = {
			style: props.inputStyle
		};
	}
	delete mergedProps.inputStyle;

	if (mergedProps.underlineShow === false) {
		mergedProps.InputProps.disableUnderline = true;
	}
	delete mergedProps.underlineShow;

	if (mergedProps.errorText) {
		mergedProps.error = true;
		mergedProps.helperText = mergedProps.errorText;
	}
	delete mergedProps.errorText;

	if (mergedProps.hintText) {
		mergedProps.placeholder = mergedProps.hintText;
	}
	delete mergedProps.hintText;

	mergedProps.onChange = (e) => onChange(e.target.value, e);

	if (mergedProps.value === null || mergedProps.value === undefined) {
		mergedProps.value = '';
	}

	mergedProps.InputProps.endAdornment = (
		<InputAdornment position="end">
			{mergedProps.InputProps.endAdornment}
			<IconButton
				onClick={onShowPopup}
				style={{ padding: '2px' }}
				disabled={props.disabled}
			>
				<EditIcon />
			</IconButton>
		</InputAdornment>
	);

	delete mergedProps.editable;
	delete mergedProps.labelStyle;
	delete mergedProps.startAdornment;
	delete mergedProps.endAdornment;
	delete mergedProps.helpText;
	delete mergedProps.popupTitle;

	return (
		<React.Fragment>
			<MuiTextField {...mergedProps} />

			<TextEditorDialog
				show={showPopup}
				title={props.popupTitle || props.label}
				value={popupValue}
				onCancel={onHidePopup}
				onOk={onSubmitPopup}
			/>
		</React.Fragment>
	);
};

TextEditor.propTypes = {
	multiline: PropTypes.bool,
	minRows: PropTypes.number,
	variant: PropTypes.string,
	inputStyle: PropTypes.object,
	underlineShow: PropTypes.bool,
	onChange: PropTypes.func,
	value: PropTypes.any,
	label: PropTypes.string,
	popupTitle: PropTypes.string,
	disabled: PropTypes.bool
};

TextEditor.defaultProps = {
	multiline: true,
	minRows: 2,
	variant: 'filled',
	inputStyle: undefined,
	underlineShow: undefined,
	onChange: null,
	value: '',
	label: '',
	popupTitle: '',
	disabled: false
};

export default TextEditor;
